import { render, staticRenderFns } from "./BoxView.vue?vue&type=template&id=0e4b9f4e&scoped=true&"
import script from "./BoxView.vue?vue&type=script&lang=js&"
export * from "./BoxView.vue?vue&type=script&lang=js&"
import style0 from "./BoxView.vue?vue&type=style&index=0&id=0e4b9f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4b9f4e",
  null
  
)

export default component.exports